import React from "react";
import { Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomToolbar from './CustomToolbar'
import "../styles/CustomDataGrid.css";

const CustomDataGrid = ({
  rows,
  columns,
  onRowClick,
  selectedRowId,
  toolbarProps = {}
}) => {
  const paginationModel = { page: 0, pageSize: 10 };

  const columnVisibilityModel = columns.reduce((model, col) => {
    model[col.field] = !col.hide;
    return model
  }, {})
  return (
    <Paper
      sx={{
        height: "auto",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: { paginationModel },
          columns: { columnVisibilityModel },
        }}
        pageSizeOptions={[10, 25, 50, 75, 100]}
        onRowClick={onRowClick}
        rowHeight={40}
        data-testid="data-grid"
        disableColumnMenu
        showToolbar
        slots={{
          toolbar: () => <CustomToolbar {...toolbarProps} />
        }}
        getRowClassName={(params) =>
          params.id === selectedRowId ? "selected-row" : ""
        }

        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
          },

          "& .MuiDataGrid-row": {
            backgroundColor: "#f0f8ff",
            "&:hover": {
              backgroundColor: "#e0f2fe ",
            },
          },
          "& .selected-row": {
            backgroundColor: "#2f539b !important",
            color: "#fff",

          },
        }}

      />
    </Paper>

  );
};

export default CustomDataGrid;
